/**
 * MSP document category / difficulty values (`msp_documents`).
 *
 * Text columns (no Postgres enum). Canonical app set used by the editor schema,
 * AI draft API, and Meridian msp-docs tools. Verified against production data
 * (procedures, client-specific, …) and the UI write options.
 */

export const MSP_DOCUMENT_CATEGORY_VALUES = [
  "procedures",
  "technical",
  "best-practices",
  "client-specific",
  "troubleshooting",
  "templates",
] as const;

export const MSP_DOCUMENT_DIFFICULTY_VALUES = [
  "beginner",
  "intermediate",
  "advanced",
] as const;

export type MspDocumentCategory = (typeof MSP_DOCUMENT_CATEGORY_VALUES)[number];
export type MspDocumentDifficulty = (typeof MSP_DOCUMENT_DIFFICULTY_VALUES)[number];
